"use client";

import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SaveIcon } from "lucide-react";

export function SaveTableViewModal({ onSaved }: any) {
  const [open, setOpen] = useState(false);
  const [viewName, setViewName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    if (!viewName.trim()) {
      return;
    }

    setIsLoading(true);

    // Simulate saving - replace with your actual save logic
    onSaved?.({ name: viewName });

    console.debug("[v0] Saving table view with name:", viewName);
    // Add your save logic here

    setIsLoading(false);
    setViewName("");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <SaveIcon />
          Save View
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Save Table View</DialogTitle>
          <DialogDescription>
            Enter a name for your table view to save it for later use.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Input
            placeholder="Enter view name..."
            value={viewName}
            onChange={(e) => setViewName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && viewName.trim()) {
                handleSave();
              }
            }}
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              setOpen(false);
              setViewName("");
            }}
          >
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={!viewName.trim() || isLoading}>
            {isLoading ? "Saving..." : "Save View"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
